import React from 'react';

export const truncateName = (name: string, maxLength: number) => {
	return name.length > maxLength ? name.slice(0, maxLength) + '...' : name;
};

export function renderMessage(text: string): React.ReactNode[] {
	const parts = text.split(/\*\*(.*?)\*\*/g);
	return parts.map((part, i) =>
		i % 2 === 1 ? React.createElement('strong', { key: i }, part) : part
	);
}
